const data = {
    categories: [
      {
        name: 'Furniture',
        subcategories: [
          {
            name: 'Seating Furniture',
            products: ['Sofa', 'Armchair', 'Stool', 'Bench'],
          },
          {
            name: 'Tables',
            products: ['Dining Table', 'Coffee Table', 'Desk', 'Side Table'],
          },
          {
            name: 'Bedroom Furniture',
            products: ['Bed', 'Mattress', 'Wardrobe', 'Dresser'],
          },
          {
            name: 'Storage Units',
            products: ['Bookshelf', 'Cabinet', 'Chest of Drawers'],
          },
          {
            name: 'Outdoor Furniture',
            products: ['Patio Set', 'Lounger', 'Garden Bench'],
          },
        ],
      },
      
      {

        name: 'Boxes and Containers',
        subcategories: [
          {
            name: 'Small Boxes',
            products: ['Book', 'Clothing', 'Electronic'],
          },
          {
            name: 'Medium Boxes',
            products: ['Kitchenware', 'Household Item'],
          },
          {
            name: 'Large Boxes',
            products: ['Bulk Items', 'Heavier Equipment'],
          },
          {
            name: 'Specialized Containers',
            products: ['Fragile Goods (Glassware/Artwork)'],
          },
        ],
      },
     {
        name: 'Appliances',
        subcategories: [
            {
                name: 'Kitchen Appliances',
                products: ['Refrigerator','Bar Fridge', 'Stove', 'Dishwasher', 'Microwave'],
            },
            {
                name: 'Laundry Appliances',
                products: ['Washing Machine','Dryer'],
            },
            {
                name: 'Entertainment  Appliances',
                products: ['Television', 'Sound System'],
            },
            {
                name: 'Small Appliances',
                products: ['Toaster', 'Blender', 'Kettle'],
            },
        ],
     },
     {
        name: 'Office Equipment',
        subcategories: [
            {
                name: 'Office Furniture',
                products: ['Office Desk', 'Chair', 'Filing Cabinet'],
            },
            {
                name: 'Electronics',
                products: ['Printer', 'Monitor', 'Desktop Computer'],
            },
            {
                name: 'Storage Items',
                products: ['Document Box', 'Shelving Unit'],
            }
        ]
     },
     {
        name: 'Sports and Musical Equipment',
        subcategories: [
            {
                name: 'Sports Gear',
                products: ['Bike', 'Treadmill','Weight Set'],
            },
            {
                name: 'Camping Equipment',
                products: ['Tent', 'Grill','Sleeping Bag'],
            },
            {
                name: 'Musical Items',
                products: ['Instrument'],
            },

        ]
     },
     {
        name: 'Industrial or Specialized Equipment',
        subcategories: [
            {
                name: 'Power Tools',
                products: ['Drill', 'Saw','Compressor'],
            },
            {
                name: 'Construction Equipment',
                products: ['Ladder', 'Scaffolding'],
            },
            {
                name: 'Gardening Tools',
                products: ['Lawnmower','Wheelbarrow'],
            },
        ],
     },
     {
        name: 'Fragile and High-Value Items',
        subcategories: [
            {
                name: 'Artwork',
                products: ['Painting', 'Sculpture'],
            },
            {
                name: 'Antiques',
                products: ['Vintage Furniture', 'Heirloom'],
            },
            {
                name: 'High-Tech Items',
                products: ['Gaming Setup', 'Lab Equipment'],
            },
        ]
     },
     {
        name: 'Miscellaneous',
        subcategories: [
            {
                name: 'Toys',
                products: ['Playset','Dollhouse'],
            },
            {
                name: 'Decorative Items',
                products: ['Mirror','Chandelier'],
            },
        ]
     }
    ],
  };

export default data;